export const defaultFlags = {
  switchToClassic: false,
  feedback: false,
  leaveBetaVersion: false,
  avatarSelector: false,
  player: {
    streaks: false,
    quests: false,
    badges: false,
    goals: false,
    focusSelector: false,
    indieProgressReport: import.meta.env.DEV,
  },
  modules: {
    vif: true,
  },
  rankings: {
    top10: false,
  },
  classicRedirect: {
    vif: true,
  },
};

/**
 * This will eventually be configurable, but going with the simplest possible implementation for now.
 */
export function getFlags() {
  return defaultFlags;
}

export function flaggedItems<T>(condition: boolean, items: T[]): T[] {
  return condition ? items : [];
}
